import { render, staticRenderFns } from "./customerHistoryTable.vue?vue&type=template&id=13cf3758&"
import script from "./customerHistoryTable.vue?vue&type=script&lang=js&"
export * from "./customerHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports